import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=af0bb102&scoped=true&"
import script from "./NewsCarousel.vue?vue&type=script&lang=js&"
export * from "./NewsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=af0bb102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0bb102",
  null
  
)

export default component.exports